import { _t } from '../../services/TranslationService.js';
import { APP_CONFIG } from "../constants/global-variables.js";

export async function getUsers() {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/userhierarchy`;
  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function createUser(data) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/createuser`;

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function blockusers(child_user, state) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/blockuser`;

  try {
    const res = await axios.post(
      url,
      {
        child_user,
        state,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function userhierarchyforall(userId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/userhierarchyforall`;

  try {
    const res = await axios.post(
      url,
      {
        user: userId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function searchUsers(user) {
  if (!user) {
    alert(_t('Please provide a valid username'));
    return;
  }

  const url = `${
    APP_CONFIG.URL.apiBasePath
  }ajaxauth/searchChildrenUsers?user=${encodeURI(user)}`;
  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {}
}
